import { pulseTemplateLifecycleSurveysApi } from 'container/pulseTemplateLifecycleSurveysApi';
import { PulseTemplateLifecycleSurveysRepository } from 'repository/PulseTemplateLifecycleSurveysRepository';

export const pulseTemplateLifecycleSurveysRepository: PulseTemplateLifecycleSurveysRepository =
  new PulseTemplateLifecycleSurveysRepository(pulseTemplateLifecycleSurveysApi);
